var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddRec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 7.5,
    fill: "#F0F1F3",
    stroke: "#666770"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9533 9.34375C18.8079 11.3057 17.3205 12.9062 15.6877 12.9062C14.0549 12.9062 12.565 11.3061 12.4221 9.34375C12.2737 7.30273 13.7209 5.78125 15.6877 5.78125C17.6545 5.78125 19.1018 7.33984 18.9533 9.34375Z",
    fill: "#666770"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6874 15.2812C12.4589 15.2812 9.18215 17.0625 8.57578 20.4246C8.50156 20.8298 8.73201 21.2188 9.15654 21.2188H22.2187C22.6432 21.2188 22.8725 20.8298 22.7994 20.4246C22.1927 17.0625 18.9159 15.2812 15.6874 15.2812Z",
    fill: "#666770"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26562 10.5298V14.6898",
    stroke: "#666770",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3438 12.6094H6.1875",
    stroke: "#666770",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRec);
export default __webpack_public_path__ + "static/media/addRec.abf932e3254827a2f104c7b89505299f.svg";
export { ForwardRef as ReactComponent };